<div class="modal success-modal">
  <div class="model-container">
    <img src="/assets/img/successfull-req.svg" width="64" height="64" class="success-icon" alt="success">
    <div class="modal-body">
      <h3 *ngIf="data?.title">{{data?.title}}</h3>
      <div class="modal-content" *ngIf="data?.customHTML" [innerHTML]="data?.customHTML"></div>
      <p *ngIf="data?.msg" class="msg">{{data?.msg}}</p>
      <div class="modal-actions">
        <button class="button primary" aria-label="Got it!" (click)="closeDialog(true)">
          {{data?.buttonText || ('success-modal.got-it' | translate)}}
        </button>
      </div>
    </div>
  </div>
</div>